import Vue from 'vue';
import VueRouter from 'vue-router';
import Main from './Main.vue';
import Index from './Index.vue';
import ViewConfig from './ViewConfig.vue';
import EditConfig from './EditConfig.vue';
import CreateConfig from './CreateConfig.vue';
import * as firebase from 'firebase';
Vue.use(VueRouter);
var firebaseConfig = {
    apiKey: 'AIzaSyDkWQzJ83vW7hzXiDT1GM_nYHXXgsnXKn4',
    authDomain: 'homepage-1cf5b.firebaseapp.com',
    databaseURL: 'https://homepage-1cf5b.firebaseio.com',
    projectId: 'homepage-1cf5b',
    storageBucket: 'homepage-1cf5b.appspot.com',
    messagingSenderId: '359082159191'
};
firebase.initializeApp(firebaseConfig);
var routes = [
    { path: '/', component: Index },
    { path: '/create', component: CreateConfig },
    { path: '/view/:config', component: ViewConfig },
    { path: '/edit', component: EditConfig },
    { path: '/edit/:config', component: EditConfig }
];
var router = new VueRouter({
    routes: routes,
    mode: 'history'
});
Vue.filter('snapshotArr', function (value) {
    var result = [];
    value.forEach(function (child) {
        result.push({
            snapshot: child,
            val: child.val(),
            key: child.key
        });
        return false;
    });
    return result;
});
var vue = new Vue({
    el: '#app',
    router: router,
    render: function (h) { return h(Main); }
});



//////////////////
// WEBPACK FOOTER
// ./src/main.ts
// module id = 88
// module chunks = 0